import React from 'react';
import { CalendarEvent, useEventsCoorgList } from './useEventsAdminList';
import { useFields } from '../../../toolympus/components/schemed';
import { SimpleList } from '../../../toolympus/components/primitives';
import { SimplePowerDocViewer } from '../../../toolympus/components/PowerDoc/SimplePowerDocViewer';
import { TimeDisplay } from '../../../toolympus/components/schemed/TimeDisplay';


interface Props {
  
}

export const CalendarCoorgPage = (props: Props) => {
  const data = useEventsCoorgList();

  const fields = useFields({
    defaultFields: [
      "title",
      "start_datetime",
      "registration_status",
      "price_option",
      "created_at",
    ],
    blacklist: [
      "description",
      "description_ru",
      "search_highlights",
    ],
    schema: data.schema,
    storageKey: "_riac_eventadm_fields",
    extraSettings: {
      description_short: { tableControl: SimplePowerDocViewer },
      created_at: { utcToLocal: true, formatAsDate: true },
      updated_at: { utcToLocal: true, formatAsDate: true },
      published_at: { utcToLocal: true, formatAsDate: true },
      actualized_at: { utcToLocal: true, formatAsDate: true },
    }
  });

  return (<>
    <SimpleList
      data={{
        ...data,
        filter: data.filter.filter,
        setFilter: data.filter.setFilter,
        create: () => Promise.resolve({ _id: -1 } as CalendarEvent),
      }}
      noCreate
      noNewItemHotkey
      fields={[
      ]}
      fieldElement={f => {
        switch(f) {
          case "end_datetime":
            return r => <TimeDisplay field="end_datetime" row={r} schema={{}} config={{ format: "HH:mm"}} />
        }
      }}
      schema={data.schema}
      getLinkValue={cr => `/my-events/${cr._id}`}
      linkFields={[ "_id", "title" ]}
      title="My Events"
      searchAuto
      searchAutoFocus
      fieldSetings={fields}
      fieldFilters={data.filtering}
      sorting={data.sorting}
      tableProps={{
        tailAnchor: data.limitTrigger.pagingAnchor,
      }}
      />
    
  </>);
}
